<template>
  <div class="facility-suboptions">  
    <div v-if="type === 'radio'">
      <div class="panel-facility__row" 
        v-for="option in optionSet"
      >
        <fieldset style="margin-left: 20px;">
          <input type="radio" 
            :id="optionSlug(option.id)" 
            :value="option.name"
            :name="optionSetId"
            :checked="optionChecked(option.id)"
            @change="selectOption(
              option.id, 
              option.name, 
              facilityCategory.id, 
              option.parents, 
              option.options,
              option.checkboxOptions,  
              option.displayInline,                    
              option.displayName
            )"
          >
          <label :for="optionSlug(option.id)">
            {{ option.name }}
          </label>

          <facility-suboptions
            :option-set="option.options" 
            :parent-id="option.id"
            :parent-facility-type="parentFacilityType"
            :parent-pending-selection="pendingSelection"
            :type="suboptionType(option.checkbox_options)"
            :require-selection="option.requireSelection"
            @showModal="showModal"
            @setParentFacilityType="setParentFacilityType"
            @setParentCheckboxSelections="setParentCheckboxSelections"
            @allowUserProfileName="allowUserProfileName"
            @disableUserProfileName="disableUserProfileName"
          ></facility-suboptions>
        </fieldset>
      </div>
    </div>

    <div v-if="type === 'checkbox'">
      <small>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>Check all that apply:</i></small>
      <fieldset style="margin-left: 20px;"
        v-for="option in optionSet"
      >
        <label :for="optionSlug(option.id)">
          <input type="checkbox" 
            :id="optionSlug(option.id)" 
            :value="option.name"
            :name="optionSlug(option.id)"
            :checked="checkboxSelected(option.id)"
            @change="selectCheckbox(
              option.id, 
              option.name, 
              option.displayName, 
              option.options,
              parentId
            )"
          >
          {{ option.name }} 
        </label>

        <div v-if="option.options && checkboxSelected(option.id)">
          <div class="panel-facility__row" 
            v-for="suboption in option.options"
          >
            <fieldset style="margin-left: 20px;">
                <label :for="optionSlug(suboption.id)">
                  <input type="radio" 
                    :id="optionSlug(suboption.id)" 
                    :value="suboption.name"
                    :name="optionSetId"
                    :checked="suboptionSelected(suboption.id)" 
                    @change="selectCheckboxSuboption(
                      option.id, 
                      suboption.id, 
                      suboption.name, 
                      suboption.displayName
                    )"
                  >
                  {{ suboption.name }}
                </label>
              </fieldset>
          </div>
        </div>
      </fieldset>

      <button class="btn btn-sm" 
        @click.prevent="setCheckboxSelections"
        :disabled="disableCheckboxSubmission"
      >Done</button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

let uuid = 0

export default {
  name: 'facility-suboptions',
  props: [
    'option-set',
    'parent-id',
    'parent-facility-type',
    'parent-pending-selection',
    'require-selection',
    'type',
  ],
  data() {
    return { 
      optionSetId: 'option-set-' + uuid,
      showSuboptions: null,
      checkboxSelections: [],
      checkboxSelectionsParent: null,
      pendingSelection: null,
    }
  },
  beforeCreate() {
    uuid += 1;
  },
  computed: {
    uuid() {
      return uuid
    },
    facilityProfiles() {
      return this.$store.getters.facilityProfiles
    },
    facilityCategory() {
      return this.$store.getters.facilityCategory
    },
    facilitySelection() {
      return this.$store.getters.facilityType
    },
    facilityCheckboxSelections() {
      return this.$store.getters.facilityCheckboxSelections
    },
    utilityId() {
      return this.$store.getters.utilityId
    },
    closestAncestor() {
      if (this.facilityCategory.parents) {
        return this.facilityCategory.parents[this.facilityCategory.parents.length - 1];
      }
      return false
    },
    checkboxSelectionCount() {
      // The number of checkboxes selected
      return Object.keys(this.checkboxSelections).length
    },
    validCheckboxSelectionsCount() {
      let filteredCheckboxSelections = this.checkboxSelections

      filteredCheckboxSelections = filteredCheckboxSelections.filter(item => {
        return item.parentId === this.parentId
      })

      return filteredCheckboxSelections.length
    },
    disableCheckboxSubmission() {
      if (this.requireSelection !== null && this.validCheckboxSelectionsCount !== null) {
        return (this.requireSelection === 1 && this.validCheckboxSelectionsCount < 1)
      }
      return false
    }
  },
  methods: {
    getObject(theObject, id) {
      let result = null;
      if (theObject instanceof Array) {
        for (let i = 0; i < theObject.length; i++) {
          result = this.getObject(theObject[i], id)
          if (result) {
            break;
          }   
        }
      } else {
        for (let prop in theObject) {
          if (prop == 'id') {
            if (theObject[prop] == id) {
              return theObject;
            }
          }
          if (theObject[prop] instanceof Object || theObject[prop] instanceof Array) {
            result = this.getObject(theObject[prop], id)
            if (result) {
              break;
            }
          } 
        }
      }
      return result
    },
    facilitySet(id) {
      return 'facility-type-' + id
    },
    suboptionType(val) {
      switch(val) {
        case 0:
          return 'radio'
        case 1: 
          return 'checkbox'
        default:
          return 'radio'
      }
    },
    selectOption(id, name, category, parents, suboptions, checkboxOptions, displayInline, displayName) {
      this.pendingSelection = id

      let inline = false
      if (displayInline && displayInline === 1) {
        inline = true
      }

      let checkboxes = false 
      if (checkboxOptions && checkboxOptions === 1) {
        checkboxes = true
      }

      // this.$store.dispatch('clearFacilityType')
      this.$store.dispatch('clearInlineFacilityPath')
      // this.clearFacilityCheckboxSelections()

      if (!suboptions || suboptions.length === 0) {
        // If there are no suboptions, set the facility type
        this.$emit('setParentFacilityType', id, name, category, parents, displayName)
        this.$emit('showModal')    

      } else if (checkboxes === true) {
        // If there are checkbox suboptions, set the facility type
        // and show the sub options
        this.$emit('setParentFacilityType', id, name, category, parents, displayName)

        if (suboptions.length < 4 || inline === true) {
          this.showSuboptions = id
        
        } else {
          this.$store.dispatch('setFacilityCategory', {
            id: id,
            name: name,
            thumb: '',
            parents: parents,
            options: suboptions,
            twoColumns: twoColumns,
            checkboxOptions: checkboxOptions,
          })
        }
      } else if (suboptions.length < 4 || inline === true) {
        // If there are less than 4 suboptions or they're manually set 
        // to inline, show them inline
        // if (this.facilitySelection.id) {
        //   this.$store.dispatch('clearFacilityType')
        //   this.clearFacilityCheckboxSelections()
        // }

        let parentsReversed = parents.slice()
        parentsReversed = parentsReversed.reverse()

        let inlinePath = []
        for (let i = 0; i < parentsReversed.length; i++) {
          inlinePath[i] = parentsReversed[i]
        }

        inlinePath.push(id)
        this.$store.dispatch('setInlineFacilityPath', inlinePath)

        this.showSuboptions = id

      } else {
        // Set the facility category to the selected item
        this.$store.dispatch('setFacilityCategory', {
          id: id,
          name: name,
          thumb: '',
          parents: parents,
          options: suboptions,            
          checkboxOptions: checkboxOptions,
        })
      }
    },
    setCheckboxSelections() {
      let checkboxSelections = []

      for (let i = 0; i < this.checkboxSelectionCount; ++i) {        
        checkboxSelections[i] = {
          id: this.checkboxSelections[i].id,
          name: this.checkboxSelections[i].name,
          displayName: this.checkboxSelections[i].displayName,
          suboption: this.checkboxSelections[i].suboption,
          parentId: this.checkboxSelections[i].parentId,
        } 
      }
      
      let filteredCheckboxSelections = checkboxSelections.filter(item => {
        return item.parentId === this.parentId
      })

      //this.$store.dispatch('setFacilityCheckboxSelections', obj)
      this.$emit('setParentCheckboxSelections', filteredCheckboxSelections)
      this.$emit('showModal')
    },
    setParentCheckboxSelections(checkboxSelections) {
      this.$emit('setParentCheckboxSelections', checkboxSelections)
    },
    selectCheckbox(id, name, displayName, suboptions, parentId) {
      let obj = {
        id: id,
        name: name,
        displayName: displayName,
        suboption: {},
        parentId: parentId,
      }

      if (this.checkboxSelected(id)) {
        let checkboxSet = this.checkboxSelections.filter(option => {
          return option.id != id
        })
        this.checkboxSelections = checkboxSet

      } else {
        this.checkboxSelections.push(obj)
      }      
    },
    // Add suboption to parent checkbox selection
    selectCheckboxSuboption(parentId, id, name, displayName) {
      for (let i = 0; i < this.checkboxSelections.length; i++) {
        if (this.checkboxSelections[i].id === parentId) {
          this.checkboxSelections[i].suboption = {
            id: id,
            name: name,
            displayName: displayName,
          }
        }
      }
    },
    showModal() {
      this.$emit('showModal')
    },
    setParentFacilityType(id, name, category, parents, displayName) {
      this.$emit('setParentFacilityType', id, name, category, parents, displayName)
    },
    checkboxSelected(id) {
      let checkboxSet = this.checkboxSelections.filter(option => {
        return option.id === id
      })

      return Object.keys(checkboxSet).length > 0
    },
    suboptionSelected(id) {
      for (let i = 0; i < this.checkboxSelections.length; i++) {
        if (this.checkboxSelections[i].suboption.id && this.checkboxSelections[i].suboption.id === id) {
          return true
        }
      }

      return false
    },
    optionChecked(id) {
      if (this.parentPendingSelection) {
        if (this.parentId != this.parentPendingSelection) {
          return false
        }

      } else if (this.pendingSelection) {
        return id === this.pendingSelection
      }

      if (id === this.facilitySelection.id) {
        return true
        
      } else if (this.showSuboptions && this.showSuboptions === id) {
        return true

      } else if (this.facilitySelection.parents && this.facilitySelection.parents.indexOf(id) > -1) {
        this.showSuboptions = id
        return true
      }

      return false
    },
    clearFacilityCheckboxSelections() {
      this.$store.dispatch('clearFacilityCheckboxSelections')
      this.checkboxSelections = []
      this.checkboxSelectionsParent = null
    },
    categoryName(id) {
      let targetCategory = this.getObject(this.facilityProfiles, id)
      return targetCategory.name
    },
    optionSlug(id) {
      return 'facility-option-' + id
    },
    allowUserProfileName() {
      this.$emit('allowUserProfileName')      
    },
    disableUserProfileName() {
      this.$emit('disableUserProfileName')
    }
  },
  watch: {
    checkboxSelections() {
      if (this.checkboxSelectionsParent !== null) {
        this.disableUserProfileName()
      }
    }
  },
  created() {
    // If checkbox selections exist in the store
    if (this.facilityCheckboxSelections && this.facilityCheckboxSelections.length > 0) {
      let firstCheckbox = this.facilityCheckboxSelections[0].id

      axios.get('/pricing-calculator/facility-profiles/' + this.utilityId + '/profile/' + firstCheckbox)
        .then(response => {
          this.checkboxSelectionsParent = response.data.parent_id

          if (!this.disableCheckboxSubmission && this.checkboxSelectionsParent === this.parentId) {
            this.allowUserProfileName()
          }
        })

      if (this.facilityCheckboxSelections.length > 0) {        
        for (let i = 0; i < this.facilityCheckboxSelections.length; i++) {

          this.checkboxSelections.push({
            id: this.facilityCheckboxSelections[i].id,
            name: this.facilityCheckboxSelections[i].name,
            displayName: this.facilityCheckboxSelections[i].displayName,
            suboption: this.facilityCheckboxSelections[i].suboption,
            parentId: this.facilityCheckboxSelections[i].parentId,
          })
        }
      }
    }

    if (this.type === 'radio') {
      this.disableUserProfileName()
    }
  }
}
</script>
